import { protectedAxiosInstance } from "./axiosManagement";

// order
export const getProject = (params) => {
  return protectedAxiosInstance
    .get("/admin/projects", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const postProject = (payload) => {
  return protectedAxiosInstance
    .post("/admin/projects", payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const updateProject = (id, payload) => {
  return protectedAxiosInstance
    .put(`/admin/projects/${id}`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getSingleProject = (id) => {
  return protectedAxiosInstance
    .get(`/admin/projects/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteProject = (id) => {
  return protectedAxiosInstance
    .delete(`/admin/projects/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getProjectQuicklist = (params) => {
  return protectedAxiosInstance
    .get("/admin/projects/quick-list", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getCustomersProjectlist = (customerId) => {
  return protectedAxiosInstance
    .get(`/admin/projects?customer_id=${customerId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getProjectApprovalList = (params) => {
  return protectedAxiosInstance
    .get("/admin/projects/pending-requests", { params })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getProjectApprovalLog = (id) => {
  return protectedAxiosInstance
    .get(`/admin/projects/${id}/change-request/status-history`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const getProjectChangeRequest = (id) => {
  return protectedAxiosInstance
    .get(`/admin/projects/${id}/change-request/view-changes`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

export const updateProjectRequestStatus = (id, payload) => {
  return protectedAxiosInstance
    .post(`/admin/projects/${id}/change-request/status-change`, payload)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
